export var WrapMode;
(function (WrapMode) {
    /// <summary>
    ///   <para>Reads the default repeat mode set higher up.</para>
    /// </summary>
    WrapMode[WrapMode["Default"] = 0] = "Default";
    WrapMode[WrapMode["Clamp"] = 1] = "Clamp";
    /// <summary>
    ///   <para>When time reaches the end of the animation clip, the clip will automatically stop playing and time will be reset to beginning of the clip.</para>
    /// </summary>
    WrapMode[WrapMode["Once"] = 1] = "Once";
    /// <summary>
    ///   <para>When time reaches the end of the animation clip, time will continue at the beginning.</para>
    /// </summary>
    WrapMode[WrapMode["Loop"] = 2] = "Loop";
    /// <summary>
    ///   <para>When time reaches the end of the animation clip, time will ping pong back between beginning and end.</para>
    /// </summary>
    WrapMode[WrapMode["PingPong"] = 4] = "PingPong";
    /// <summary>
    ///   <para>Plays back the animation. When it reaches the end, it will keep playing the last frame and never stop playing.</para>
    /// </summary>
    WrapMode[WrapMode["ClampForever"] = 8] = "ClampForever";
})(WrapMode || (WrapMode = {}));
//# sourceMappingURL=WrapMode.js.map